import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { Session, Transaction } from '../../../types/checkout';
import Hero from './Hero';
import MainArea from './MainArea';
import { RequestLog } from '../../../types/audit/generated';
import Card from '../../../components/Card';

export interface TransactionDetailsProps extends WithTranslation {
    transaction: Transaction;
    session?: Session;
    requestLogs: RequestLog[] | undefined;
    reportTransaction: (accountId: string, transaction: Transaction, language: string) => void;
    openEventHistoryDetailsModal: (details: any) => void;
}

const TransactionDetails = (
    {
        transaction,
        session,
        requestLogs,
        reportTransaction,
        openEventHistoryDetailsModal,
    }: TransactionDetailsProps
) => {
    return (
        <Wrapper>
            <Card noPadding marginBottom="8px">
                <Hero
                    session={session}
                    transaction={transaction}
                    reportTransaction={reportTransaction}
                />
            </Card>
            <Card noPadding>

                <MainArea
                    transaction={transaction}
                    session={session}
                    requestLogs={requestLogs}
                    openEventHistoryDetailsModal={openEventHistoryDetailsModal}
                />
            </Card>

        </Wrapper>
    );
};

export default withTranslation()(TransactionDetails);

const Wrapper = styled.div`
    position: relative;
`;
